import React, { useContext, useState, useEffect } from "react";
import { Card, CardContent } from "@mui/material";
import { AppBarSpacer } from "../../../css/Admin-css/listing-css";
import CountryListDatatable from "../DataTable/dt-countryList";
import { AxiosContext } from "../../../app/assets/axios/admin/AxiosComponent";
import { useForm } from "react-hook-form";
import SearchField from "../DataTable/SearchField/SearchField";

import {
    fetchCountryList,
    handleDataTablePerRowsChange,
} from "../../../actions/admin/actionCreators";
import CollapsedBreadcrumbs, { BreadcrumbsContext } from "../../../layouts/admin/breadcrumb";

export default function CountryList() {
    const api = useContext(AxiosContext);
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(50);
    const [startFrom, setStart] = useState(0);
    const [pending, setPending] = useState(true);
    const [breadcrumbArr, setBreadcrumbArr] = React.useState([
        {
            text: "Country",
            link: "",
        },
    ]);

    const searchField = [
        {
            name: "code",
            label: "Code",
            placeholder: "Code",
            marginType: "normal",
            type: "text",
        },
        {
            name: "name",
            label: "Name",
            placeholder: "Name",
            marginType: "normal",
            type: "text",
        },
    ];

    const { handleSubmit, control, reset, getValues } = useForm({
        defaultValues: {
            code: "",
            name: "",
        },
    });

    const onSubmit = handleSubmit(async (param) => {
        param["page"] = startFrom;
        param["per_page"] = perPage;

        const response = await fetchCountryList({
            api: api,
            data: param,
        });

        if (response) {
            if (response.status === 200) {
                if (response.data.total_records > 0) {
                    setData(response.data.data);
                    setTotalRows(response.data.total_records);
                }
            }
        }
    });

    const onReset = () => {
        reset();
        onSubmit();
    };

    const getCountryListData = async () => {
        setPending(true);

        const param = {};
        param["page"] = startFrom;
        param["per_page"] = perPage;
        param["code"] = getValues("code");
        param["name"] = getValues("name");

        const response = await fetchCountryList({
            api: api,
            data: param,
        });

        if (response) {
            if (response.status === 200) {
                setPending(false);
                if (response.data.total_records > 0) {
                    setData(response.data.data);
                    setTotalRows(response.data.total_records);
                }
            }
        }
    };

    const handlePageChange = async (page) => {
        const startPage = (page - 1) * perPage;
        setStart(startPage);
    };

    const handlePerRowsChange = async (newPerPage) => {
        const param = {};
        param["page"] = 0;
        param["per_page"] = newPerPage;
        param["code"] = getValues("code");
        param["name"] = getValues("name");

        const response = await handleDataTablePerRowsChange({
            api: api,
            url: "getCountryList?",
            data: param,
        });

        setData(response.data.data);
        setPerPage(newPerPage);
    };

    useEffect(() => {
        getCountryListData();
    }, [startFrom]);

    return (
        <>
            <BreadcrumbsContext.Provider value={[breadcrumbArr, setBreadcrumbArr]} >
                <CollapsedBreadcrumbs />
            </BreadcrumbsContext.Provider>
            <div className="row">
                <div className="col-md-12">
                    <SearchField
                        control={control}
                        searchField={searchField}
                        onSubmit={onSubmit}
                        onReset={onReset}
                        onCreate="/admin/country/create"
                    />

                    <AppBarSpacer />

                    <Card>
                        <CardContent>
                            <CountryListDatatable
                                totalRows={totalRows}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                fileteredData={data}
                                startFrom={startFrom}
                                pending={pending}
                            ></CountryListDatatable>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </>

    );
}
